import {
	Progress,
} from '@sketchpixy/rubix';
import React from 'react';


export class FlightIndicator extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

	scheduledPassengersWeight() {
		return _.reduce(this.props.reservations, (weight, reservation) => {
			return weight + reservation.totalWeight();
		}, 0) + (this.props.pilot && this.props.pilot.profile.weight ? this.props.pilot.profile.weight : 0 );
	}
	
	availableTotalWeight() {
		if (!this.props.montgolfiere)
			return 0;

		return (this.props.temp ? this.props.montgolfiere.maxWeight["temp" + this.props.temp] : this.props.montgolfiere.defaultWeight) - this.props.montgolfiere.defaultWeight;
	}
	
	availableRemainingWeight() {
		return this.availableTotalWeight() - this.scheduledPassengersWeight();	
	}
	
	scheduledPassengersCount() {
		return _.reduce(this.props.reservations, (count, reservation) => {
			return count + reservation.passengers.length;
		}, 0);
	}
	
	availablePassengersCount() {
		if (!this.props.montgolfiere)
			return 0;

		return this.props.montgolfiere.maxPassengers;
	}

	weightRatio() {
		const ratio = this.scheduledPassengersWeight() / this.availableTotalWeight() * 100;

		return ratio > 100 ? 100 : ratio;
	}

	passengersRatio() {
		const ratio = this.scheduledPassengersCount() / this.availablePassengersCount() * 100;

		return ratio > 100 ? 100 : ratio;
	}

    render() {
		return (
			<div>
				<Progress striped danger={this.weightRatio() >= 100} value={this.weightRatio()} label={this.scheduledPassengersWeight() + "Kg / " + this.availableTotalWeight() + "Kg - Restant : " + this.availableRemainingWeight() + "Kg"}/>
				<Progress striped danger={this.passengersRatio() >= 100} value={this.passengersRatio()} label={this.scheduledPassengersCount() + " / " + this.availablePassengersCount()  + " passagers"}/>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/flights/FlightIndicator.js
 **/